import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-[#0D1117]/10 px-6 sm:px-12 lg:px-20 pt-20 sm:pt-28 pb-10 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20">
        <div className="lg:col-span-6">
          <div className="flex items-center mb-5">
            <img src="/logo-horizontal.png" alt="Fitygrity" className="h-9 w-auto object-contain rounded-md" />
          </div>
          <p className="text-sm sm:text-base text-[#374151] leading-relaxed max-w-md">
            An endurance house composing expeditions, virtual challenges and athletic gatherings
            for the modern tribe. New Delhi — Global Operations.
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#6B7280] mb-5">Explore</p>
          <ul className="space-y-3">
            {[
              { label: "Challenges", href: "/challenges" },
              { label: "Events", href: "/events" },
              { label: "Expeditions", href: "/expeditions" },
              { label: "Journal", href: "/journal" },
              { label: "Articles", href: "/articles" },
              { label: "Training Hub", href: "/training" },
              { label: "Community", href: "/community" },
              { label: "My Profile", href: "/profile" },
              { label: "About Us", href: "/about" },
              { label: "Leadership", href: "/leadership" },
              { label: "Gear Room", href: "/gallery" },
              { label: "Race Calendar", href: "/calendar" },
              { label: "Ask AI", href: "/ask" },
              { label: "Contact", href: "/contact" },
              { label: "Privacy Policy", href: "/privacy-policy" },
              { label: "Terms of Service", href: "/terms" },
            ].map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-sm text-[#374151] hover:text-[#FF4E00] transition-colors duration-300"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#6B7280] mb-5">Contact</p>
          <a
            href="mailto:info@fitygrity.com"
            data-testid="footer-email-link"
            className="group inline-flex items-center gap-2 text-sm text-[#0D1117] hover:text-[#FF4E00] transition-colors duration-300"
          >
            info@fitygrity.com
            <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:rotate-45" />
          </a>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#6B7280] mt-4">
            New Delhi &middot; Global Operations
          </p>
        </div>
      </div>

      <div
        data-testid="footer-brand"
        className="font-serif font-light leading-none text-[#0D1117]/[0.07] select-none text-[19vw] tracking-tight -mb-[3vw] text-center"
        aria-hidden="true"
      >
        FITYGRITY
      </div>

      <div className="relative flex flex-col sm:flex-row items-center justify-between gap-3 pt-8 border-t border-[#0D1117]/10">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#6B7280]">
          &copy; {new Date().getFullYear()} Fitygrity. All rights reserved.
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#6B7280]">
          Endurance, elevated.
        </p>
      </div>
    </footer>
  );
}
